<!-- Значок приложения из общего набора PWA-иконок. -->
<template>
  <img
    :src="source"
    :width="size"
    :height="size"
    alt=""
    aria-hidden="true"
  >
</template>

<script>
export default {
  name: "TruckoIcon",
  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
  computed: {
    source() {
      return `${process.env.BASE_URL}img/icons/android-chrome-192x192.png`;
    },
  },
};
</script>
